import { useState } from 'react'
import { SummaryDetail } from '@/types'
import { ReadButton } from './'
import { VoiceModal } from '../Voice'
import { useRouter } from 'next/router'

interface Props {
  summary: SummaryDetail
}

export const Readable: React.FC<Props> = ({ summary }) => {
  const router = useRouter()
  const [open, setOpen] = useState(false)
  return (
    <>
      {summary?.voice !== '' && (
        <>
          <ReadButton
            type="voice"
            onClick={() => setOpen(true)}
            isThemselves={+summary.id == 1594}
          />
          <VoiceModal
            isOpen={open}
            summaryId={summary?.id}
            image={summary?.image}
            title={summary?.title}
            voice={summary?.voice}
            onClose={() => setOpen(false)}
          />
        </>
      )}
      <div className="mb-[5px]" />
      <ReadButton
        type="pdf"
        onClick={() => router.push(`/summary/pdfviewer/${summary?.id}`)}
      />
    </>
  )
}
